export const firebaseConfig = {
  apiKey: 'AIzaSyCHElP0-sl-8xbqXqypzeQjsu5qp3Z6ALM',
  authDomain: '',
  projectId: 'combust-d03ad',
  databaseURL: 'https://combust-d03ad.firebaseio.com',
  storageBucket: 'gs://combust-d03ad.appspot.com',
  messagingSenderId: '',
  appId: '',
};
